import { Component, Input, OnInit } from '@angular/core';
import { FromToDetail } from '../../../../../_objects/report-element';
import { ReportSection } from '../../../../models/report-preview/report-section';
import { Notifier, OfflineReportPreviewService, MousePoint } from '../../../../../_services/offline-report-preview.service';

@Component({
    selector: 'app-report-section',
    templateUrl: './report-section.component.html',
    styleUrls: ['./report-section.component.scss'],
    standalone: false
})
export class ReportSectionOfflineComponent implements OnInit {
  @Input() public pageKey: string;
  @Input() public sectionKey: string;
  @Input() public elementLocation: string;
  public reportSection: ReportSection;
  private notifier: Notifier;
  private resizeMarkerSize: number;
  private resizing: boolean;

  readonly containerStyle='position: absolute; box-sizing: border-box;';

  constructor(public designService: OfflineReportPreviewService) {
    this.resizeMarkerSize = 36;
    this.resizing = false;
  }

  public ngOnInit() {
    this.notifier = {
      componentName: 'report-section.component',
      ids: { pageId: this.pageKey, elementId: this.sectionKey }
    };
    this.reportSection = this.designService.getSection(this.sectionKey);
  }

  public onClick(event: MouseEvent) { }

  public getResizeMarkerSize(): string {
    return this.resizeMarkerSize + 'px';
  }

  public getResizeMarkerLeft(horizontal: string): string {
    switch (horizontal) {
      case 'left':
        return (this.resizeMarkerSize / 2 * -1) + 'px';
      case 'center':
        return ((this.reportSection.getWidthPx() / 2) - (this.resizeMarkerSize / 2)) + 'px';
      case 'right':
        return (this.reportSection.getWidthPx() - (this.resizeMarkerSize / 2)) + 'px';
      default:
        return '';
    }
  }

  public getResizeMarkerTop(vertical: string): string {
    switch (vertical) {
      case 'top':
        return (this.resizeMarkerSize / 2 * -1) + 'px';
      case 'middle':
        return ((this.reportSection.getHeightPx() / 2) - (this.resizeMarkerSize / 2)) + 'px';
      case 'bottom':
        return (this.reportSection.getHeightPx() - (this.resizeMarkerSize / 2)) + 'px';
      default:
        return '';
    }
  }

  public onDragStart(event: DragEvent) {
    event.dataTransfer.setData('text', this.sectionKey);
    event.dataTransfer.effectAllowed = 'move';

    const fromDetail: FromToDetail = {
      location: this.reportSection.getLocation(),
      pageId: this.pageKey
    };
    const dragPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
  }

  public onDragOver(event: DragEvent) {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    event.stopPropagation();
  }

  public onDrop(event: DragEvent) {
    event.preventDefault();
    const template  = { ...this.designService.originTemplate };
    template.reportTemplateContent = JSON.stringify(this.designService.getTemplate());
    const dragElemId = event.dataTransfer.getData('text');

    const toDetail: FromToDetail = {
      location: this.reportSection.getLocation(),
      pageId: this.pageKey
    };
    const dropPoint: MousePoint = {
      onElementX: this.reportSection.getLeftPx() + event.offsetX,
      onElementY: this.reportSection.getTopPx() + event.offsetY
    };
    event.dataTransfer.clearData('text');
    event.stopPropagation();
  }

  public onResizeMarkerDown(event: MouseEvent, vertical: string, horizontal: string) {
    event.preventDefault();
    this.resizing = true;
    const beginPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
    event.stopPropagation();
  }

  public onResizing(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  public onResizeMarkerUp(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }

  public onResizeMarkerLeave(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    event.stopPropagation();
  }

  public getStyle(): object {
    return {
      top: this.reportSection.top,
      left: this.reportSection.left,
      width: this.reportSection.width,
      height: this.reportSection.height,
      position: 'absolute',
      border: '1px dashed #333'
    };
  }
}
